import axios from 'axios'
import urls from './urls'
import querystring from 'querystring'

/**
 * fetch Location list
 * @param {Object} filters
 *  @param {Number} page Page number
 *  @param {Number} size list size
 *  @param {String} name search text
 *  @param {String} sort sorting format: field;ASC|DESC
 */
const fetchBaspList = async function ({ page, size, name, sort }) {
  try {
    let filters = {
      page, size, name, sort
    }
    console.log('TCL: filters', filters)
    const res = await axios.get(urls.baspList + '?' + querystring.stringify(filters))
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * fetch a basp detail
 * @param {Number} id Basp Id
 */
const fetchBaspDetail = async function (id) {
  try {
    let res = await axios.get(urls.baspDetail + '/' + id)
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * create or edit a basp
 * @param {Object} form data form input
 * @param {String} form.reason basp reason
 * @param {Boolean} form.needConfirm basp needConfirm
 * @param {Boolean} form.freeText basp reeText
 * @param {Boolean} form.active basp isActive
 * @param {Number} form.id basp Id for edit
 * @param {Number} form.createdAt basp createdAt for edit
 * @param {Number} form.createdBy basp Id for edit
 */
const createEditBasp = async function ({ id, reason, needConfirm, freeText, active, createdAt, createdBy }) {
  try {
    let res
    let isFreeText = freeText
    let isActive = active
    const data = {
      id,
      reason,
      needConfirm,
      isFreeText,
      isActive,
      createdAt,
      createdBy
    }
    console.log('TCL: data', data)
    if (id) {
      res = await axios.put((urls.baspDetail + '/' + id), data)
    } else {
      res = await axios.post(urls.baspDetail, data)
    }
    return res.data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  fetchBaspList,
  fetchBaspDetail,
  createEditBasp
}
